// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-footer--1K7hH","contact-us":"Footer-contact-us--1rOFA"};